import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

import { getNextTwelveMonths } from 'app/utils'


export default function SelectStaticMonth({ ...props }) {

    const myProps = {
        options: getNextTwelveMonths(),
        placeholder: 'All sources',
        isClearable: false, 
        isMulti: false,
        firstSelect: true,
        icon: { icon: 'calendar' },
        ...props
    }

    return <SelectSeeker {...myProps} />
}